var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit } from "vue-property-decorator";
import ExpressionBase from "~/components/system-manage/strategy-config/expression-base.vue";
import { ValidatorService } from "~/utils/validator.service";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
var AddQueue = /** @class */ (function (_super) {
    __extends(AddQueue, _super);
    function AddQueue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            labelName: "",
            labelStatus: "READY",
            formulaJson: "[]"
        };
        _this.rules = {
            labelName: { required: true, message: "请输入队列名称" },
            labelStatus: { required: true, message: "请选择队列状态" }
        };
        return _this;
    }
    /**
     * 验证基础配置数据
     */
    AddQueue.prototype.validate = function () {
        var _this = this;
        var form = this.$refs.form;
        return Promise.all([
            form.validate(),
            this.validateExpression(),
            this.validateBreaketComplete()
        ]).then(function () { return _this.emitBaseChange(_this.model); });
    };
    AddQueue.prototype.emitBaseChange = function (v) { };
    AddQueue.prototype.emitClose = function () {
        this.strategyDataSet = [];
        this.model.id = "";
        this.refreshData();
    };
    AddQueue.prototype.refreshData = function () { };
    Object.defineProperty(AddQueue.prototype, "strategyDataSet", {
        // private priorityList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        get: function () {
            if (!this.model.formulaJson)
                return [];
            return JSON.parse(this.model.formulaJson);
        },
        set: function (value) {
            this.model.formulaJson = JSON.stringify(value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 验证数据是否完整
     */
    AddQueue.prototype.validateExpression = function () {
        var _this = this;
        var rules = {
            relation: { required: true, message: "请选择链接关系符" },
            variable: { required: true, message: "请选择字段" },
            symbol: { required: true, message: "请选择操作符" },
            value: { required: true, message: "缺少期望值" }
        };
        var results = this.strategyDataSet.map(function (v) {
            return ValidatorService.validate(v, rules);
        });
        return Promise.all(results)
            .then(function () { return true; })
            .catch(function (_a) {
            var errors = _a.errors;
            if (errors.length)
                _this.$message(errors[0].message);
            return Promise.reject(false);
        });
    };
    /**
     * 验证连接符是否完整
     */
    AddQueue.prototype.validateBreaketComplete = function () {
        if (!this.strategyDataSet.length) {
            this.$message("请配置数据规则");
            return Promise.reject("Error");
        }
        var result = this.strategyDataSet.reduce(function (s, c) {
            if (c.leftBracket === "(")
                s += 1;
            if (c.leftBracket === "((")
                s += 2;
            if (c.rightBracket === ")")
                s -= 1;
            if (c.rightBracket === "))")
                s -= 2;
            return s;
        }, 0);
        if (result === 0) {
            return Promise.resolve(true);
        }
        else {
            var message = result > 0 ? "缺少右括号 ）" : "缺少左括号（";
            this.$message(message);
            return Promise.reject("Error");
        }
    };
    AddQueue.prototype.addNewConfigLine = function () {
        var addFlag = true;
        if (this.strategyDataSet.length) {
            var lastLine = this.strategyDataSet[this.strategyDataSet.length - 1];
            addFlag = !!lastLine.relation;
        }
        if (addFlag) {
            this.strategyDataSet.push({
                relation: "",
                variable: "",
                symbol: "",
                leftBracket: "",
                rightBracket: "",
                value: ""
            });
        }
        else {
            this.$message.warning("请完善数据规则");
        }
    };
    /**
     * 重置
     */
    AddQueue.prototype.reset = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    /**
     * 确定
     */
    AddQueue.prototype.submit = function () {
        var _this = this;
        var validates = this.validate().catch(function (e) { return Promise.reject(e); });
        validates.then(function (x) {
            _this.labelingStrategyService
                .saveLabelingStrategy(_this.model)
                .subscribe(function (data) {
                _this.$message.success("操作成功！");
                _this.emitClose();
                _this.reset();
            });
        });
    };
    /**
     * 作废/终止
     */
    AddQueue.prototype.ObsoleteClick = function (val) {
        var _this = this;
        var ObsoleteModel = {
            id: this.model.id,
            labelStatus: val === 1 ? "ABOLISHED" : "TERMINATED"
        };
        this.labelingStrategyService
            .updateLabelStatus(ObsoleteModel)
            .subscribe(function (data) {
            _this.$message.success("操作成功！");
            _this.emitClose();
            _this.reset();
        });
    };
    AddQueue.prototype.refresh = function (modifyData) {
        this.reset();
        if (modifyData.id) {
            this.model.labelName = modifyData.labelName;
            this.model.labelStatus = modifyData.labelStatus;
            this.model.formulaJson = modifyData.formulaJson;
            this.model.id = modifyData.id;
        }
    };
    __decorate([
        Dependencies(LabelingStrategyService)
    ], AddQueue.prototype, "labelingStrategyService", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], AddQueue.prototype, "modifyData", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], AddQueue.prototype, "openData", void 0);
    __decorate([
        Emit("add-queue")
    ], AddQueue.prototype, "emitBaseChange", null);
    __decorate([
        Emit("close")
    ], AddQueue.prototype, "emitClose", null);
    __decorate([
        Emit("refreshData")
    ], AddQueue.prototype, "refreshData", null);
    AddQueue = __decorate([
        Component({
            components: {
                ExpressionBase: ExpressionBase
            }
        })
    ], AddQueue);
    return AddQueue;
}(Vue));
export default AddQueue;
